<template>
  <div class="navigator-container">
    <router-link :to="pathToWeek" :accesskey="previousWeek ? accessKeyPrev : accessKeyNext">
      <i :class="['arrow', { left: previousWeek, hidden: isNavigatorHidden }]" />
    </router-link>
  </div>
</template>

<script>
import { NAVIGATION_ACCESS_KEYS } from '../constants/index';

const navigationKeys = NAVIGATION_ACCESS_KEYS.weekNav;

export default {
  name: 'WeekNavigator',
  props: {
    previousWeek: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      required: true,
    },
    nextPath: {
      type: String,
      required: true,
    },
    isNavigatorVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      accessKeyPrev: navigationKeys['previous week'],
      accessKeyNext: navigationKeys['next week'],
    };
  },
  computed: {
    pathToWeek() {
      return this.nextPath !== '' ? `${this.basePath}/${this.nextPath}/` : `${this.basePath}/`;
    },
    isNavigatorHidden() {
      return !this.isNavigatorVisible;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';

.navigator-container {
  display: inline-block;

  i.arrow {
    height: 0px;
    width: 0px;
    border: 6px solid;
    border-color: transparent transparent transparent $black-color;
    display: inline-block;
    margin: 0 0 0 10px;

    &.left {
      margin: 0 10px 0 0;
      transform: rotate(-180deg);
    }

    &.hidden {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WeekNavigator.vue